// extracted by mini-css-extract-plugin
module.exports = {"th":"TableHeader_th__3Jbq9"};